import React, { createContext, useContext, useState, useEffect } from 'react';
import { getAuth } from 'firebase/auth';
import { CompanyContext } from './CompanyContext';
import { useAuth } from './AuthContext';
import axios from '../config/axios';
import { logger } from '../utils/logger';

const PaymentContext = createContext();

export const PaymentProvider = ({ children }) => {
  const [isPaymentPending, setIsPaymentPending] = useState(false);
  const [paymentData, setPaymentData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasSubscribed, setHasSubscribed] = useState(false);
  const { selectedCompany } = useContext(CompanyContext);
  const { user } = useAuth();

  const checkPaymentStatus = async (companyId) => {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
      
      if (!currentUser || !companyId) {
        setIsLoading(false);
        return;
      }

      const idToken = await currentUser.getIdToken();
      
      const API_BASE = process.env.REACT_APP_API_BASE_URL || axios.defaults.baseURL || '';
      const response = await fetch(
        `${API_BASE}/api/check-payment/${companyId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`,
          },
        }
      );

      const data = await response.json();
      
      // Ajuste de lógica: pagamento pendente quando hasSubscribed === false e message indica pendência
      const isPending = data && data.hasSubscribed === false && typeof data.message === 'string' && data.message.includes('pagamento mensal está pendente');
      setHasSubscribed(!!data?.hasSubscribed);
      if (isPending) {
        setIsPaymentPending(true);
        setPaymentData({
          userEmail: currentUser.email,
          subscriptionPlan: data.subscriptionPlan || 'especialista'
        });
      } else {
        setIsPaymentPending(false);
        setPaymentData(null);
      }
    } catch (error) {
      console.error('Erro ao verificar status do pagamento:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const companyId = selectedCompany?.companyId;
    if (companyId && user?.uid) {
      logger.log('Empresa selecionada, verificando status do pagamento:', companyId);
      setIsLoading(true);
      checkPaymentStatus(companyId);
    } else {
      setIsPaymentPending(false);
      setPaymentData(null);
      setHasSubscribed(false);
      setIsLoading(false);
    }
  }, [selectedCompany?.companyId, user?.uid]);

  return (
    <PaymentContext.Provider value={{ 
      isPaymentPending, 
      paymentData, 
      isLoading,
      hasSubscribed,
      checkPaymentStatus 
    }}>
      {children}
    </PaymentContext.Provider>
  );
};

export const usePayment = () => {
  const context = useContext(PaymentContext);
  if (!context) {
    throw new Error('usePayment deve ser usado dentro de um PaymentProvider');
  }
  return context;
}; 